import React, { useEffect, useState } from 'react';
import { Slide, ToastContainer } from 'react-toastify';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { CogIcon, LogoutIcon } from '@heroicons/react/outline';
import { classNames } from '../utils';
import { MENU_NAVIGATION_LINKS } from './constants';
import { StoreKeys, useStore } from '../shared/store';
import { useTranslation } from 'react-i18next';
import { Disclosure } from '@headlessui/react';
import { Avatar } from '../elements/avatar';
import { animated, useSpring } from '@react-spring/web';
import { APP_NAME } from '../constants';
import LOGO from '../../assets/images/xtremislogo.png'

export const MenuContainer = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { remove, get, set } = useStore();
    const [profile, setProfile] = useState<any>({});
    const [path, setPath] = useState<string>('');
    const [isOpened, setIsOpened] = useState<boolean>(true);
    const props = useSpring({ width: isOpened ? 248 : 80 });
    const location = useLocation();

    const handelLogout = () => {
        remove();
        window.location.href = '/';
    };

    useEffect(() => {
        setProfile(get(StoreKeys.Profile));
    }, []);

    return (
        <>
            <div className="flex flex-row h-screen">
                <animated.div style={props}>
                    <animated.div
                        className={classNames(
                            'relative flex flex-col h-screen bg-[#1c1d3d] pr-4'
                        )}
                        style={props}
                    >
                        <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
                            {/* <div className={"w-full pr-2 flex justify-end"}>
                                <button className={""}
                                        onClick={() => setIsOpened(!isOpened)}>
                                    {isOpened
                                        ? <LockClosedIcon className={"h-6 w-6 text-primary hover:text-secondary"}/>
                                        : <LockOpenIcon className={"h-6 w-6 text-primary hover:text-secondary"}/>
                                    }
                                </button>
                            </div> */}
                            {isOpened ? (
                                <div className="flex-shrink-0 flex flex-col items-center px-4">
                                     <img
                                        className="h-8 w-auto"
                                        src={LOGO}
                                        alt="Workflow"
                                    /> 
                                    {/* <div
                                        className="pb-4 cursor-pointer"
                                        onClick={() => navigate('/')}
                                    >
                                        <span className='text-white pt-[5px]'>{'< '}</span>
                                        <span className='text-white text-[12px]'>{t('common.button.back')}</span>
                                    </div> */}
{/*                                     <div className={'text-[16px] font-medium text-white'}>
                                        TripTango
                                    </div> */}

                                </div>
                            ) : null}
                            <nav className="mt-5 px-2 space-y-1">
                                {MENU_NAVIGATION_LINKS.map((item, index) =>
                                    !item.children ? (
                                        <div key={index}>
                                            {
                                                <Link
                                                    key={item.name}
                                                    data-testid={`menu-${item.name}`}
                                                    onClick={() => {
                                                        setPath(item.href as string);
                                                        set('vehicles-tab-index', 0);
                                                        set('driver-tab-index', 0);

                                                    }}
                                                    to={item.href as string}
                                                    title={item.name}
                                                    className={classNames(
                                                        location.pathname ===
                                                            item.href ||
                                                            path === item.href
                                                            ? 'group flex items-center px-2 py-2 text-base font-medium rounded-md bg-[#006bc6] text-white hover:bg-[#006bc6] hover:text-white'
                                                            : 'group flex items-center px-2 py-2 text-base font-medium rounded-md text-gray-400 hover:text-white',
                                                        isOpened
                                                            ? 'justify-start'
                                                            : 'justify-center'
                                                    )}
                                                >
                                                    {item.icon ? (
                                                        <item.icon
                                                            className={
                                                                'w-[12] h-[12] text-center text-primary mr-2'
                                                            }
                                                        />
                                                    ) : null}
                                                    {isOpened ? (
                                                        <>{t(item.name)}</>
                                                    ) : null}
                                                </Link>
                                            }
                                        </div>
                                    ) : (
                                        <Disclosure
                                            as="div"
                                            key={item.name}
                                            className="space-y-1"
                                            defaultOpen={true}
                                        >
                                            {({ open }) => (
                                                <>
                                                    <Disclosure.Button
                                                        data-testid={`menu-${item.name}`}
                                                        className={classNames(
                                                            item.current
                                                                ? 'bg-[#344048] text-white'
                                                                : 'bg-[#344048] text-white hover:bg-[#344048] hover:text-white',
                                                            'group w-full flex items-center pr-2 p-2 text-left  font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500'
                                                        )}
                                                    >
                                                        <div
                                                            className={
                                                                'w-full text-[13px] leading-4 flex justify-between'
                                                            }
                                                        >
                                                            <div className="flex justify-start mt-1">
                                                                <div className="mt-[4px]">
                                                                    {item.icon ? (
                                                                        <item.icon
                                                                            className={
                                                                                'w-[12px] h-[12px] pr-2'
                                                                            }
                                                                        />
                                                                    ) : null}
                                                                </div>

                                                                <div>
                                                                    {isOpened ? (
                                                                        <span className="pl-2">
                                                                            {t(
                                                                                item.name
                                                                            )}
                                                                        </span>
                                                                    ) : (
                                                                        <CogIcon
                                                                            className={
                                                                                'h-4 w-4'
                                                                            }
                                                                        />
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div>
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    className={classNames(
                                                                        open
                                                                            ? item.name !==
                                                                                'Informes'
                                                                                ? 'text-gray-400 rotate-90 '
                                                                                : 'text-gray-300'
                                                                            : 'text-gray-300 ',
                                                                        'mr-2 flex-shrink-0 h-5 w-5 transform group-hover:text-gray-300 transition-colors ease-in-out duration-150'
                                                                    )}
                                                                    fill="none"
                                                                    viewBox="0 0 24 24"
                                                                    stroke="currentColor"
                                                                    strokeWidth={
                                                                        2
                                                                    }
                                                                >
                                                                    <path
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                        d="M9 5l7 7-7 7"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </Disclosure.Button>
                                                    <Disclosure.Panel
                                                        static={
                                                            item.name ===
                                                            'Informes'
                                                        }
                                                        className="space-y-1"
                                                    >
                                                        <>
                                                            {item.children?.map(
                                                                (
                                                                    subItem,
                                                                    index
                                                                ) => (
                                                                    <div
                                                                        key={
                                                                            index
                                                                        }
                                                                    >
                                                                        {
                                                                            <Link
                                                                                key={
                                                                                    subItem.name
                                                                                }
                                                                                onClick={() => {
                                                                                    setPath(subItem.href as string);
                                                                                    set('vehicles-tab-index', 0);
                                                                                    set('driver-tab-index', 0);

                                                                                }}
                                                                                to={
                                                                                    subItem.href as string
                                                                                }
                                                                                title={
                                                                                    subItem.name
                                                                                }
                                                                                data-testid={`menu-${subItem.name}`}
                                                                                className={classNames(
                                                                                    window
                                                                                        .location
                                                                                        .pathname ===
                                                                                        subItem.href ||
                                                                                        path ===
                                                                                        subItem.href
                                                                                        ? 'group w-full flex items-center pr-2 py-2 text-sm font-medium bg-[#006bc6] text-white rounded-md'
                                                                                        : 'group w-full flex items-center pr-2 py-2 text-sm font-medium text-gray-400 rounded-md hover:text-white',
                                                                                    isOpened
                                                                                        ? 'justify-start pl-6 '
                                                                                        : 'justify-center pl-6'
                                                                                )}
                                                                            >
                                                                                {subItem.icon ? (
                                                                                    <subItem.icon
                                                                                        className={
                                                                                            'w-6 h-6 text-center text-white mr-2'
                                                                                        }
                                                                                    />
                                                                                ) : null}
                                                                                {isOpened ? (
                                                                                    <>
                                                                                        {t(
                                                                                            subItem.name
                                                                                        )}
                                                                                    </>
                                                                                ) : null}
                                                                            </Link>
                                                                        }
                                                                    </div>
                                                                )
                                                            )}
                                                        </>
                                                    </Disclosure.Panel>
                                                </>
                                            )}
                                        </Disclosure>
                                    )
                                )}
                            </nav>
                        </div>
                        <div className="flex-shrink-0 flex pr-4 pb-8">
                            <Link
                                to="#"
                                className="flex-shrink-0 group block"
                            >
                                <div className="flex items-center pl-[10px]">
                                    {profile && (
                                        <>
                                            <Avatar name={profile.name || profile.email} />
                                            {isOpened
                                                ? <div className="ml-3">
                                                    <p className="text-base font-medium text-white group-hover:text-white">
                                                        {profile.name || profile.email}
                                                    </p>
                                                </div>
                                                : null}
                                        </>
                                    )}
                                    <button
                                        onClick={handelLogout}
                                        className="flex space-x-1 items-center flex-shrink-0 group block "
                                    >
                                        <LogoutIcon className="h-5 w-5 text-white mx-2" />
                                        {/*   {isOpened
                                            ? <span>
                                                {t('common.button.logout')}
                                            </span>
                                            : null} */}
                                    </button>
                                </div>
                            </Link>
                        </div>
                    </animated.div>
                </animated.div>

                <div className="flex flex-col flex-1 overflow-y-scroll">
                    <Outlet />
                </div>
            </div>

            <ToastContainer
                position="top-center"
                hideProgressBar
                autoClose={5000}
                transition={Slide}
                closeOnClick
            />
        </>
    );
};

